/** Types and constants shared by the server and the web app. */
export const ROLES = ['direction', 'office'];
export const THEMES = ['system', 'light', 'dark'];
export const PASSWORD_MIN_LENGTH = 10;
/** Labels shown in the interface for each role. */
export const ROLE_LABELS = {
    direction: 'Direction',
    office: 'Office',
};
/** Label of the Owner (the person in OWNER_EMAIL), shown instead of the role. */
export const OWNER_LABEL = 'Master';
export const LOCK_PASSWORD_MIN_LENGTH = 12;
export * from './i18n.js';
export * from './reference.js';
export * from './bookings.js';
export * from './planning.js';
export * from './dateText.js';
//# sourceMappingURL=index.js.map